import { Stack } from "@chakra-ui/react";
import { Skeleton } from "@chakra-ui/skeleton";
import { ReactNode, useEffect } from "react";

import CustomWrapper from "components/Chakra/CustomWrapper";
import IntersectionObserverWrapper from "components/IntersectionObserverWrapper";
import MetaHead from "components/MetaHead";
import { useStoryblokTypeUser } from "contexts/StoryblokTypeUser";
import InfoBanner from "./component/InfoBanner";
import Searchbox from "./component/Searchbox";
import Services from "./component/Services";
import ListingsPromo from "./component/ListingsPromo";
import TabsWrapper from "./component/TabsWrapper";
import UserTypeSection from "./component/UserTypeSection";
import { FindData } from "@ud/api/newPhpApi/__generated__/newPhpApi.generated";

type HomepageProps = {
  blogComponents: ReactNode | null;
  listingsHouseSale: FindData["offers"];
  listingsFlatRent: FindData["offers"];
};

const NewHomepage = ({
  blogComponents,
  listingsFlatRent,
  listingsHouseSale,
}: HomepageProps) => {
  const { checkLocalStorageUserType, isViewTypeUserSection, isLoaded } =
    useStoryblokTypeUser();

  useEffect(() => {
    checkLocalStorageUserType();
  }, []);

  return (
    <>
      <MetaHead
        noNamePlug
        title="UlovDomov.cz | Největší nabídka pronájmů na jednom místě."
        description="Největší nabídka pronájmu bytů a spolubydlení v ČR. Přes 1 000 nových nabídek denně. Najděte pronájem, kterému budete říkat domov."
      />
      <Searchbox
        title="Nový domov na jeden klik"
        subtitle="Najděte bydlení podle svých představ kdekoliv"
        heroSrc="/img/scenes/NewHomepage/hero.webp"
      />
      {!isLoaded ? (
        <CustomWrapper mt="80px" maxW="1360px">
          <Skeleton isLoaded={isLoaded} w="100%" h="40px" mb="40px" />
          <Stack direction={{ base: "column", md: "row" }}>
            {[...Array(3)].map((_, index) => (
              <Skeleton
                key={index}
                isLoaded={isLoaded}
                h="500px"
                w="100%"
                borderRadius="16px"
              />
            ))}
          </Stack>
        </CustomWrapper>
      ) : (
        <>
          {isViewTypeUserSection && <UserTypeSection />}
          <IntersectionObserverWrapper>
            <TabsWrapper />
          </IntersectionObserverWrapper>
        </>
      )}
      <InfoBanner />
      <ListingsPromo
        title="Pronájem byt"
        subTitle="Nejnovější inzeráty pronájmu bytů v ČR."
        button={{ label: "Zobrazit další pronájmy", href: "/pronajem/bytu" }}
        offers={listingsFlatRent}
      />

      <ListingsPromo
        title="Prodej domu"
        subTitle="Nejnovější inzeráty prodeje domů v ČR."
        button={{ label: "Zobrazit další prodeje", href: "/prodej/domu" }}
        offers={listingsHouseSale}
      />
      <Services />

      <IntersectionObserverWrapper>
        {blogComponents}
      </IntersectionObserverWrapper>
    </>
  );
};

export default NewHomepage;
